export const EMAIL_OPT_IN_PREFERENCES_KEY = "email_opt_in";
